"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconButton = void 0;
const IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const OptionsIcon_1 = __importDefault(require("@opsbase/web-icons/icons/OptionsIcon"));
const react_1 = __importStar(require("react"));
const Tooltip_1 = __importDefault(require("../Tooltip"));
const makeMyClasses = (round, size, noOpacity) => ({
    root: {
        padding: 0,
        borderRadius: round ? '50%' : 4,
        width: size || 24,
        height: size || 24,
        backgroundColor: 'transparent',
        transition: 'opacity 0.3s',
        '&:hover': {
            opacity: noOpacity ? undefined : 0.2,
            backgroundColor: 'transparent',
        },
        '& .SVGIconRoot': {
            transition: 'color 0.3s',
        },
    },
});
function IconButton(props) {
    const { icon = react_1.default.createElement(OptionsIcon_1.default, { fontSize: "small", style: { padding: 2 } }), disabled = false, link, tooltip, tooltipDelay = 750, size = 24, target, style, onMouseEnter, onMouseLeave, onMouseDown, onMouseUp, onClick, classes, round, noOpacity, } = props;
    const myCss = (0, web_css_1.default)(makeMyClasses, [round, size, noOpacity], classes);
    const href = link ? (link.startsWith('http') ? link : '#' + link) : undefined;
    return (0, react_1.useMemo)(() => {
        const content = tooltip ? (react_1.default.createElement(Tooltip_1.default, { enterDelay: tooltipDelay, style: { height: '100%' }, tip: tooltip }, icon)) : (icon);
        return (react_1.default.createElement(IconButton_1.default, { style: style, disabled: disabled, classes: { root: myCss.root + ' newStyle' }, color: "inherit", "aria-haspopup": "true", onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onClick: onClick, href: href, target: target }, content));
    }, [
        myCss,
        disabled,
        href,
        icon,
        onClick,
        onMouseDown,
        onMouseEnter,
        onMouseLeave,
        onMouseUp,
        style,
        target,
        tooltip,
        tooltipDelay,
    ]);
}
exports.IconButton = IconButton;
exports.default = IconButton;
